import Vue from 'vue'
import VueRouter from 'vue-router'

import HomePage from '@/views/HomePage.vue'
import ChemicalIndustry from '@/views/ChemicalIndustry.vue'
import ProjectManagement from '@/views/ProjectManagement.vue'
import OracleAgile from '@/views/OracleAgile.vue'
import ElectronTechnology from '@/views/ElectronTechnology.vue'
import MedicalEquipment from '@/views/MedicalEquipment.vue'
import MachineryManufactur from '@/views/MachineryManufactur.vue'
import Semiconductor from '@/views/Semiconductor.vue'
import AboutUs from '@/views/AboutUs.vue'
import BeautyMakeup from '@/views/BeautyMakeup.vue'
import FoodBeverage from '@/views/FoodBeverage.vue'
import PLMAI from '@/views/PLMAI.vue'
import NewsList from '@/views/NewsList.vue'
import NewsDetail from '@/views/NewsDetail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    meta: { title: '璞华易研PLM' },
    // component: () => import(/* webpackChunkName: "about" */ '../views/HomePage.vue')
    component: HomePage
  },
  {
    path: '/ChemicalIndustry',
    name: 'chemicalIndustry',
    meta: { title: '化工材料PLM' },
    // component: () => import(/* webpackChunkName: "about" */ '../views/ChemicalIndustry.vue')
    component: ChemicalIndustry
  },
  {
    path: '/ProjectManagement',
    name: 'projectManagement',
    meta: { title: '项目管理PMS' },
    // component: () => import(/* webpackChunkName: "about" */ '../views/ProjectManagement.vue')
    component: ProjectManagement
  },
  {
    path: '/OracleAgile',
    name: 'oracleAgile',
    meta: { title: 'Oracle Agile PLM' },
    // component: () => import(/* webpackChunkName: "about" */ '../views/OracleAgile.vue')
    component: OracleAgile
  },
  {
    path: '/ElectronTechnology',
    name: 'electronTechnology',
    meta: { title: '电子科技行业' },
    // component: () => import(/* webpackChunkName: "about" */ '../views/ElectronTechnology.vue')
    component: ElectronTechnology
  },
  {
    path: '/MedicalEquipment',
    name: 'medicalEquipment',
    meta: { title: '医疗器械行业' },
    // component: () => import(/* webpackChunkName: "about" */ '../views/MedicalEquipment.vue')
    component: MedicalEquipment
  },
  {
    path: '/MachineryManufactur',
    name: 'machineryManufactur',
    meta: { title: '机械制造行业' },
    // component: () => import(/* webpackChunkName: "about" */ '../views/MachineryManufactur.vue')
    component: MachineryManufactur
  },
  {
    path: '/Semiconductor',
    name: 'semiconductor',
    meta: { title: '半导体行业' },
    // component: () => import(/* webpackChunkName: "about" */ '../views/Semiconductor.vue')
    component: Semiconductor
  },
  {
    path: '/BeautyMakeup',
    name: 'beautyMakeup',
    meta: { title: '日化美妆行业' },
    // component: () => import(/* webpackChunkName: "about" */ '../views/BeautyMakeup.vue')
    component: BeautyMakeup
  },
  {
    path: '/FoodBeverage',
    name: 'foodBeverage',
    meta: { title: '食品饮料行业' },
    // component: () => import(/* webpackChunkName: "about" */ '../views/BeautyMakeup.vue')
    component: FoodBeverage
  },
  {
    path: '/PLMAI',
    name: 'plmAi',
    meta: { title: 'PLM+AI配方研发系统_AI贝叶斯优化_EOBO配方推荐' },
    component: PLMAI
  },
  {
    path: '/News',
    name: 'newsList',
    meta: { title: '新闻资讯' },
    component: NewsList
  },
  {
    path: '/NewsDetail/:sourceId',
    name: 'newsDetail',
    meta: { title: '新闻详情' },
    component: NewsDetail
  },
  {
    path: '/AboutUs',
    name: 'aboutUs',
    meta: { title: '关于我们' },
    // component: () => import(/* webpackChunkName: "about" */ '../views/AboutUs.vue')
    component: AboutUs
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
